import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";
import { AuthState } from "@/types";

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      token: null,
      user: null,
      isUserDataLoading: false,
      isDeleting: false,
      error: null,
      hasHydrated: false,

      // State actions
      login: (res) => set({ token: res.token, user: res.user, error: null }),
      logout: () => set({ token: null, user: null, error: null }),
      updateUser: (patch) =>
        set((s) => ({ user: s.user ? { ...s.user, ...patch } : s.user })),
      setUserDataLoading: (isUserDataLoading) => set({ isUserDataLoading }),
      setIsDeleting: (v) => set({ isDeleting: v }),
      setError: (error) => set({ error }),      
      _setHasHydrated: (v) => set({ hasHydrated: v }),
    }),
    {
      name: "auth-storage",
      storage: createJSONStorage(() => localStorage),
      partialize: (s) => ({ token: s.token, user: s.user }),
      onRehydrateStorage: () => (state) => state?._setHasHydrated(true),
    }
  )
);
